import React, { useEffect } from "react";
import { Navbar, NavItem } from "../components/Navbar";
import { TOSModal } from "../components/UserTOS/TOSModal";
import { useStudent } from "../contexts/auth/StudentContext";
import { useLoggedIn } from "../contexts/auth/LoggedInContext";
import { UserGuideModal } from "../components/UserGuide/UserGuideModal";

export function UserPageLayout({ children }: { children: React.ReactNode }) {
  const [openTOSModal, setOpenTOSModal] = React.useState(false);

  const { studentDetail, refreshStudentDetail } = useStudent();

  const { unreadMessages, pendingRequests } = useLoggedIn();

  const [showUserGuideModal, setShowUserGuideModal] = React.useState(false);

  useEffect(() => {
    const studentTOS = studentDetail?.StudentTOS;
    if (studentTOS && studentTOS.date_updated > studentTOS.date_user_agreed_on) {
        setOpenTOSModal(true);
    } else {
        setOpenTOSModal(false);
    }
    if (studentDetail?.UserGuideCompleted === false) {
      setShowUserGuideModal(true);
    }
  }, [studentDetail]);

  const handleCloseUserGuideModal = async () => {
    setShowUserGuideModal(false);
    await refreshStudentDetail();
  }

  const navProps: NavItem[]  = [
    { name: "Messages", path: "/messages", notification: unreadMessages },
    { name: "Tutors", path: "/tutors" },
    { name: "Calendar", path: "/user-calendar", notification: pendingRequests },
    { name: "Account", path: "/account" },
  ];

  const handleCloseTOSModal = async () => {
    setOpenTOSModal(false);
    await refreshStudentDetail();
  }

  return (
    <>
      <Navbar navProps={navProps} showLocation={true} />
      {showUserGuideModal && <UserGuideModal handleCloseTOSModal={handleCloseUserGuideModal} />}
      {openTOSModal && <TOSModal handleCloseTOSModal={handleCloseTOSModal} />}
      {children}
    </>
  );
  }